import {
  KeycloakLogoIcon,
  Skeleton,
  VKLogoIcon,
  YandexLogoIcon,
} from '@affine/component';
import { Button } from '@affine/component/ui/button';
import { popupWindow } from '@affine/core/utils';
import { appInfo } from '@affine/electron-api';
import { OAuthProvider as OAuthProviderType } from '@affine/graphql';
import { useI18n } from '@affine/i18n';
import { GithubIcon, GoogleDuotoneIcon } from '@docnboard/icons/blocksuite/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { type ReactElement, useCallback } from 'react';

import { ServerConfigService } from '../../../modules/cloud';

const OAuthProviderMap: Record<
  OAuthProviderType,
  {
    icon: ReactElement;
  }
> = {
  [OAuthProviderType.Google]: {
    icon: <GoogleDuotoneIcon />,
  },

  // DNB_FIX добавить Яндекс ID
  [OAuthProviderType.Yandex]: {
    icon: <YandexLogoIcon />,
  },

  // DNB_FIX добавить VK ID
  [OAuthProviderType.VK]: {
    icon: <VKLogoIcon />,
  },

  [OAuthProviderType.Keycloak]: {
    icon: <KeycloakLogoIcon />,
  },

  [OAuthProviderType.GitHub]: {
    icon: <GithubIcon />,
  },

  [OAuthProviderType.OIDC]: {
    // TODO(@catsjuice): Add OIDC icon
    icon: <GoogleDuotoneIcon />,
  },
};

export function OAuth() {
  const serverConfig = useService(ServerConfigService).serverConfig;
  const oauth = useLiveData(serverConfig.features$.map(r => r?.oauth));
  const oauthProviders = useLiveData(
    serverConfig.config$.map(r => r?.oauthProviders)
  );

  if (!oauth) {
    return <Skeleton height={50} />;
  }

  return oauthProviders?.map(provider => (
    <OAuthProvider key={provider} provider={provider} />
  ));
}

function OAuthProvider({ provider }: { provider: OAuthProviderType }) {
  const { icon } = OAuthProviderMap[provider];

  const t = useI18n();

  const onClick = useCallback(() => {
    let oauthUrl =
      (BUILD_CONFIG.isElectron ? BUILD_CONFIG.serverUrlPrefix : '') +
      `/oauth/login?provider=${provider}`;

    if (BUILD_CONFIG.isElectron) {
      oauthUrl += `&client=${appInfo?.schema}`;
    }

    popupWindow(oauthUrl);
  }, [provider]);

  return (
    <Button
      key={provider}
      variant="primary"
      block
      size="extraLarge"
      //DNB_FIX уменьшен отступ
      style={{ marginTop: 14, width: '100%' }}
      prefix={icon}
      onClick={onClick}
    >
      {t[`Continue with ${provider}`]()}
    </Button>
  );
}
